module.exports = __WEBPACK_EXTERNAL_MODULE_35__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/dialog/dist/mdc.dialog","commonjs2":"@material/dialog/dist/mdc.dialog","commonjs":"@material/dialog/dist/mdc.dialog","amd":"@material/dialog/dist/mdc.dialog","umd":"@material/dialog/dist/mdc.dialog"}
// module id = 35
// module chunks = 0